<template>
	<div id="app" v-if="isRouterAlive">
		<router-view></router-view>
	</div>
</template>
<script>
	import confing from '../configHttp.js'
	export default {
		name: 'App',
		provide() {
			return {
				reload: this.reload //  声明一个变量
			}
		},
		data() {
			return {
				isRouterAlive: true
			}
		},
		created() {
			this.$router.beforeEach((to, from, next) => {
				var routearr = localStorage.getItem('meaurouter');
				if (to.path == '/login' || from.path == '/login' || to.path == '/homepage' || to.path == '/gjck') {
					next();
				} else {
					var userInfo = localStorage.getItem('userInfo');
					if (!userInfo) {
						localStorage.clear();
						router.push('/login');
					}
					if ((routearr.indexOf(to.meta.roles[0])) == -1) {
						next(from.path);
					} else {
						next();
					}
				} 
			});
			let title = document.getElementsByTagName('title')[0]
			let favicon = document.getElementById('icon')
			if (confing.company == 'hls') {
				favicon.href = '/nssb.svg'
				title.innerText = '和利时-税务管理系统'
			} else if (confing.company == 'shm') {
				favicon.href = '/nssb.svg'
				title.innerText = '税慧盟·纳税申报'
			}else{
				favicon.href = '/nssb.svg'
				title.innerText = '纳税申报'
			}
		},
		methods: {
			reload() {
				// 通过 this.isRouterAlive 控制 router-view 达到刷新效果
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
			}
		}
	};
</script>
<style>
.ql-editor {
  white-space: normal !important;
}

.ql-container {
  white-space: pre-wrap !important;
}
.ql-align-center{
	  text-align: center;
	  }
	  .ql-align-right{
	  text-align: right;
	  }
	  .ql-indent-1{
	  padding-left: 16px;
	  }
	  .ql-indent-2{
	  padding-left: 32px;
	  }
	  .ql-indent-3{
	  padding-left: 48px;
	  }
	  .ql-indent-4{
	  padding-left: 64px;
	  }
	  .ql-indent-5{
	  padding-left: 80px;
	  }
	  .ql-indent-6{
	  padding-left: 96px;
	  }
	  .ql-indent-7{
	  padding-left: 112px;
	  }
	  .ql-indent-8{
	  padding-left: 128px;
	  }
	@import "./assets/css/main.css";
</style>
